import axios from "axios";
import { API_URL, getAuthHeader } from ".";
import { State } from "../Models/State";
import { UserLevel } from "../Models/UserLevel";
import { Industry } from "../Models/Industry";
import { FileType } from "../Models/FileType";
import { ResponseModel } from "../Models/ResponseModel";
import { PageType } from "../Models/PageType";
import { Subscription } from "../Models/Subscription";
import { SubscriptionWithMemberCount } from "../Models/SubscriptionWithMemberCount";
import { Tag } from "../Models/Tag";
import { Member } from "../Models/Member";
import { QBReferenceItemDto } from "../Models/QBReferenceItemDto";
import { DetectedBoothResponse } from "../Models/DetectedBooth";

class CommonApi {
  static getStates() {
    return axios.get<State[]>(`${API_URL}/api/common/states`, getAuthHeader());
  }
  static getMembers() {
    return axios.get<Member[]>(
      `${API_URL}/api/common/members`,
      getAuthHeader()
    );
  }
  static getUserLevels() {
    return axios.get<UserLevel[]>(
      `${API_URL}/api/common/userlevels`,
      getAuthHeader()
    );
  }
  static getIndustries() {
    return axios.get<Industry[]>(
      `${API_URL}/api/common/industries`,
      getAuthHeader()
    );
  }
  static getFileTypes() {
    return axios.get<FileType[]>(
      `${API_URL}/api/common/filetypes`,
      getAuthHeader()
    );
  }
  static getSubscriptions() {
    return axios.get<Subscription[]>(
      `${API_URL}/api/common/subscriptions`,
      getAuthHeader()
    );
  }
  static getSubscriptionsWithMemberCounts() {
    return axios.get<SubscriptionWithMemberCount[]>(
      `${API_URL}/api/common/subscriptions/with-member-counts`,
      getAuthHeader()
    );
  }
  static addFile(request: FormData) {
    return axios.post<ResponseModel>(
      `${API_URL}/api/common/addFile`,
      request,
      getAuthHeader()
    );
  }
  static addImageFile(request: FormData) {
    return axios.post<ResponseModel>(
      `${API_URL}/api/common/upload`,
      request,
      getAuthHeader()
    );
  }
  static uploadFloorplan(request: FormData) {
    return axios.post<{
      url: string;
      suggestedBooths?: DetectedBoothResponse[];
    }>(`${API_URL}/api/common/upload-floorplan`, request, getAuthHeader());
  }

  static detectBoothsFromPdf(request: FormData) {
    return axios.post<DetectedBoothResponse[]>(
      `${API_URL}/api/common/detect-booths`,
      request,
      getAuthHeader()
    );
  }

  static detectBoothsFromImageUrl(imageUrl: string) {
    const form = new FormData();
    form.append("imageUrl", imageUrl);
    return axios.post<DetectedBoothResponse[]>(
      `${API_URL}/api/common/detect-booths`,
      form,
      getAuthHeader()
    );
  }
  static deleteFile(id: number) {
    return axios.post<ResponseModel>(
      `${API_URL}/api/common/deleteFile/${id}`,
      {},
      getAuthHeader()
    );
  }
  static getPageTypes() {
    return axios.get<PageType[]>(
      `${API_URL}/api/common/pagetypes`,
      getAuthHeader()
    );
  }
  static getTags() {
    return axios.get<Tag[]>(`${API_URL}/api/common/tags`, getAuthHeader());
  }
  static deleteSitePage(id: number) {
    return axios.post<ResponseModel>(
      `${API_URL}/api/common/deleteSitePage/${id}`,
      {},
      getAuthHeader()
    );
  }
  static getQBItems() {
    return axios.get<QBReferenceItemDto[]>(
      `${API_URL}/api/qb/quickbooks-items`, // or your endpoint
      getAuthHeader()
    );
  }
}

export default CommonApi;
